import { ChevronRightIcon } from '@chakra-ui/icons'
import { Box, Center, Grid, Heading, Image, Text } from '@chakra-ui/react'
import React from 'react'
import { Link } from 'react-router-dom';
import { Data } from '../Context/DataContext';
import { useContext } from 'react'

export default function TopBrands() {
    const { handleManufacturer } = useContext(Data);

    const topBrandData = [
        {
            id: 1,
            title: 'ARISTO',
            off: 'CD UPTO 11 %',
            manu:"Aristo Pharmaceuticals Pvt Ltd"
        },
        {
            id: 2,
            title: 'FDC',
            off: 'CD UPTO 16 %',
            manu:"FDC Ltd"
        },
        {
            id: 3,
            title: 'CIPLA',
            off: 'CD UPTO 14 %',
            manu:"Cipla Ltd"
        },
        {
            id: 4,
            title: 'USV',
            off: 'CD UPTO 12 %',
            manu:"USV Ltd"
        },
        {
            id: 5,
            title: 'GSK',
            off: 'CD UPTO 18 %',
            manu:"Glaxo SmithKline Pharmaceuticals Ltd"
        }
    ]
    
  return (
    <Box p='0 25px' mb='30px'>
        <Box display={'flex'} alignItems='center' justifyContent='space-between' mb='30px'>
            <Box>
            <Heading as='h2' fontSize='25px' fontWeight='500'>Top Companies Of The Day</Heading>
            </Box>
        </Box>
        <Grid overflow={{base: 'scroll', md: 'hidden'}} pb='20px' templateColumns={`repeat(${topBrandData.length},1fr)`} gap={3}>
            {
                topBrandData.map(((el, index) => (
                    <Box w={{base: '200px', md: '18vw'}} key={el.id} bg='#fff' p='30px 20px' borderRadius={6} boxShadow='md' cursor='pointer'>
                        <Link to="/products" onClick={() => handleManufacturer(el.manu)}>
                            <Center>
                            <Image h={'150px'}  objectFit="cover" margin={"0 auto"} src={process.env.PUBLIC_URL+`/Images/UDYOGTB${index+1}.jpg`}></Image></Center></Link>
                        <Center><Text mt='20px' fontWeight={'600'}>{el.title}</Text></Center>
                        <Center><Text mt='30px' color='' fontWeight={500} fontSize={'15px'}>{el.off}</Text></Center>
                    </Box>
                )))
            }
        </Grid>
        
    </Box>
  )
}
